import React, { useEffect, useState } from 'react'
import { Button, Input } from '@byscott-io/corebyscott'
import Lex from '../../Shared/Lex'
import { Store } from 'react-notifications-component'

const NewComment = ({ saveNewComment, commentable, hideNewComment }) => {
  const key = `new-comment-${commentable?.type}-${commentable?.id}`
  const [saveEnabled, setSaveEnabled] = useState(false)
  const [value, setValue] = useState(null)
  const form = {}

  const save = () => {
    saveNewComment(form.comment?.value, () => {
      Store.addNotification({
        title: 'Comment Added',
        message: 'Your comment has been posted!',
        type: 'success',
        insert: 'bottom',
        container: 'bottom-left',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: { duration: 3000 }
      })

      form.comment.value = ''

      localStorage.removeItem(key)

      hide()
    })
  }
  const loadLocalStorage = () => {
    if (localStorage.getItem(key)) { setValue(localStorage.getItem(key)) }
  }

  useEffect(() => {
    loadLocalStorage()
    if (value) {
      if (!saveEnabled) setSaveEnabled(true)
    } else {
      if (saveEnabled) setSaveEnabled(false)
    }
  })

  const saveLocalStorage = () => {
    if (form.comment?.value) {
      localStorage.setItem(key, form.comment?.value)
      if (!saveEnabled) setSaveEnabled(true)
    } else {
      localStorage.removeItem(key)
      if (saveEnabled) setSaveEnabled(false)
    }
  }

  const hide = () => hideNewComment()

  return (
    <div className="cbs-scope border1 rounded5px margin-bottom-5px">
      <div className="margin-top-5px">
        <Input
          innerRef={el => form.comment = el} placeholder="Comment" defaultValue={value}
          onChange={saveLocalStorage}
        />
      </div>
      <div className="text-right margin5">
        <Button size="sm" color="success" onClick={save} disabled={!saveEnabled}><Lex term="save" /></Button>
      </div>
    </div>)
}

export default NewComment
